module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 100,
      "imaSrc": "design/gray-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Una buena práctica para administrar el dinero es realizar el flujo de efectivo, pero…",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Una buena práctica para ")]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v(" administrar el dinero es realizar el ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v("flujo de efectivo, pero…")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Qué es un flujo de efectivo?',
      "videoEmbed": "ADMINISTRACIONDINERO13FlujoDedEfectivo(ant44).mp4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated rotateInUpLeft dura_2",
    attrs: {
      "row": "",
      "wrap": "",
      "mt-1": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('h2', {
    staticClass: "app-title font-red "
  }, [_vm._v("¿Qué es un flujo de efectivo?")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "adorn-bottom",
    attrs: {
      "xs12": "",
      "sm8": "",
      "mt-3": "",
      "mb-5": ""
    }
  }, [_c('p', [_vm._v("\n        Es un "), _c('strong', [_vm._v("plan detallado")]), _vm._v(" de ingresos  y egresos que permite  conocer la situación financiera y realizar \n        ajustes en la medida que sean necesarios."), _c('br'), _c('br'), _vm._v("\n        \n        La mayoría de personas normalmente no piensa en el flujo  de efectivo en términos de "), _c('strong', [_vm._v("ingresos y gastos,")]), _vm._v(" \n        de hecho se cree que este solo es importante para los negocios;  sin embargo, \n        cada persona tiene uno propio, y determinar si es positivo o negativo, es "), _c('strong', [_vm._v("vital")]), _vm._v(" para la \n        administración del dinero.\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558fb7bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-13.vue
// module id = 983
// module chunks = 1